import { useEffect } from 'react';

import { track } from './analytics/index.js';
import { AddToCartButton } from './components/AddToCartButton.js';
import { PlacardColorPicker } from './components/PlacardColorPicker.js';
import { PreviewPlaceholder } from './components/PreviewPlaceholder.js';
import { PricePanel } from './components/PricePanel.js';
import { QuantityInput } from './components/QuantityInput.js';
import { RequestQuoteButton } from './components/RequestQuoteButton.js';
import { SizePicker } from './components/SizePicker.js';
import { TextLinesEditor } from './components/TextLinesEditor.js';
import { VinylColorPicker } from './components/VinylColorPicker.js';

export function App() {
  useEffect(() => {
    track({ name: 'configurator_opened' });
  }, []);

  return (
    <div className="layout">
      <header className="layout__header">
        <h1>Custom Patch Configurator</h1>
      </header>

      <section className="layout__preview" aria-label="Live preview">
        <PreviewPlaceholder />
      </section>

      <section className="layout__form" aria-label="Configuration">
        <SizePicker />
        <TextLinesEditor />
        <VinylColorPicker />
        <PlacardColorPicker />
        <QuantityInput />
      </section>

      <section className="layout__checkout">
        <PricePanel />
        <AddToCartButton />
        <RequestQuoteButton />
      </section>
    </div>
  );
}
